<template>
  <el-breadcrumb separator="/">
    <el-breadcrumb-item v-for="(item, index) in breadcrumbs" :key="index" :to="item.path">
      {{ item.meta.title }}
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const breadcrumbs = ref([])

const getBreadcrumbs = () => {
  // 不需要面包屑的路由
  if (route.path === '/dashboard') {
    breadcrumbs.value = [{ path: '/dashboard', meta: { title: '首页' } }]
    return
  }
  
  // 生成面包屑
  let matched = route.matched.filter(item => item.meta && item.meta.title)
  
  // 如果第一个不是首页，添加首页
  if (matched[0].path !== '/dashboard') {
    matched = [{ path: '/dashboard', meta: { title: '首页' } }].concat(matched)
  }
  
  breadcrumbs.value = matched
}

// 监听路由变化
watch(() => route.path, getBreadcrumbs, { immediate: true })
</script>

<style lang="scss" scoped>
.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 60px;
}
</style> 